/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_CampusInputs */

const en_mk_nav_campus = /** @type {(inputs: Mk_Nav_CampusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus Program`)
};

const id_mk_nav_campus = /** @type {(inputs: Mk_Nav_CampusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus Program`)
};

/**
* | output |
* | --- |
* | "Campus Program" |
*
* @param {Mk_Nav_CampusInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_campus = /** @type {((inputs?: Mk_Nav_CampusInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_CampusInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_campus(inputs)
	return en_mk_nav_campus(inputs)
});